// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"e0348ba1","283":"e888ebda","311":"4a3bf193","312":"39376a83","326":"b2126314","370":"39ffc207","380":"b4910380","391":"46c1320d","450":"78a2d3ae","571":"73e05707","698":"2e103e39","821":"3718c8a4","906":"23c66fca","924":"b8e7a038","967":"a698bef8"}[chunkId] + ".chunk.js";
};